import { normalizeRoleSlug } from "../../../public/utils/roleAccess";
import {
  MAINTENANCE_RECORDS_CONTROL_SUBMODULE_SLUG,
  MAINTENANCE_RECORDS_SUBMODULE_SLUG,
} from "./maintenancePermissionSlugs";

function permRow(permMap, slug) {
  const row = permMap?.[slug];
  return row && typeof row === "object" ? row : {};
}

function submodulePerm(permMap, slug, type) {
  if (!permMap || !slug) return false;
  const row = permMap[slug];
  if (!row || typeof row !== "object") return false;
  return Boolean(row[type]);
}

/** Office maintenance records — User builder `maintenance-records` row. */
function maintenanceRecordsStylePerms(row) {
  const canView = Boolean(row.view);
  const canCreate = Boolean(row.create);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  return {
    canView: canView || canCreate,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: false,
    canDeleteMasters: false,
    canExport: canView || canCreate,
    isAdmin: false,
  };
}

/** Admin maintenance control — User builder `maintenance-records-control` row. */
function maintenanceControlStylePerms(permMap) {
  const row = permRow(permMap, MAINTENANCE_RECORDS_CONTROL_SUBMODULE_SLUG);
  const recordsRow = permRow(permMap, MAINTENANCE_RECORDS_SUBMODULE_SLUG);
  const canView = Boolean(row.view);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  const canCreate = Boolean(row.create) || Boolean(recordsRow.create);
  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: canView && canEdit,
    canDeleteMasters: canDelete,
    canExport: canView,
    isAdmin: canView,
  };
}

/**
 * Permissions for one maintenance screen (User builder submodule row).
 * All roles — including admin — follow User builder only.
 */
export function buildMaintenancePermissionsForScreen(
  permMap = {},
  _roleSlug = "",
  screenSlug = "",
) {
  const slug = normalizeRoleSlug(screenSlug);

  if (slug === MAINTENANCE_RECORDS_SUBMODULE_SLUG) {
    return maintenanceRecordsStylePerms(permRow(permMap, slug));
  }

  if (slug === MAINTENANCE_RECORDS_CONTROL_SUBMODULE_SLUG) {
    return maintenanceControlStylePerms(permMap);
  }

  return buildMaintenancePermissions(permMap);
}

/** Combined maintenance permissions from User builder submodule rows. */
export function buildMaintenancePermissions(permMap = {}) {
  const canControl = submodulePerm(permMap, MAINTENANCE_RECORDS_CONTROL_SUBMODULE_SLUG, "view");
  const recordsRow = permRow(permMap, MAINTENANCE_RECORDS_SUBMODULE_SLUG);
  const controlRow = permRow(permMap, MAINTENANCE_RECORDS_CONTROL_SUBMODULE_SLUG);
  const canView =
    Boolean(recordsRow.view) ||
    Boolean(recordsRow.create) ||
    canControl;
  const canCreate = Boolean(recordsRow.create) || Boolean(controlRow.create);
  const canEdit = Boolean(recordsRow.edit) || Boolean(controlRow.edit);
  const canDelete = Boolean(controlRow.delete);

  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: canControl && Boolean(controlRow.edit),
    canDeleteMasters: canControl && Boolean(controlRow.delete),
    canExport: canView,
    isAdmin: canControl,
  };
}
